import styled, { css } from 'styled-components';

export interface BannerContainerProps {
  textPosition: 'left' | 'right';
}

const leftPositionedTextCss = css`
  grid-template-columns: 1fr 400px;
  grid-template-areas: "home-content home-phone";

  @media all and (max-width: 1100px) {
    grid-template-columns: 1fr 317px;
  }
  @media all and (max-width: 760px) {
    grid-template-columns: 1fr 273px;
  }
`;

const rightPositionedTextCss = css`
  grid-template-columns: 400px 1fr;
  grid-template-areas: "home-phone home-content";

  @media all and (max-width: 1100px) {
    grid-template-columns: 317px 1fr;
  }
  @media all and (max-width: 960px) {
    grid-template-columns: 273px 1fr;
  }
`;

export const BannerContainer = styled.div<BannerContainerProps>`
  max-width: 1440px;
  justify-self: center;
  display: grid;
  column-gap: 50px;
  padding: 4em 6em;
  box-sizing: border-box;
  position: relative;

  ${({ textPosition }) => textPosition === 'left' ? leftPositionedTextCss : rightPositionedTextCss};

  @media all and (max-width: 920px) {
    column-gap: 32px;
    padding: 4em 3em;
  }
  @media all and (max-width: 760px) {
    grid-template-columns: 1fr;
    row-gap: 2em;
    grid-template-areas: "home-content" "home-phone";
  }
  @media all and (max-width: 420px) {
    padding: 4em 1.5em;
  }
`;
